import { CheckoutConfig, CheckoutStepType } from '@spartacus/checkout/base/root'

export const ebCheckoutConfig: CheckoutConfig = {
  checkout: {
    steps: [
      // Change the payment details step to be before the delivery mode
      {
        id: 'paymentDetails',
        name: 'checkoutProgress.orderReferenceStep',
        routeName: 'checkoutPaymentDetails',
        type: [CheckoutStepType.PAYMENT_DETAILS]
      },
      {
        id: 'deliveryAddress',
        name: 'checkoutProgress.deliveryAddress',
        routeName: 'checkoutDeliveryAddress',
        type: [CheckoutStepType.DELIVERY_ADDRESS]
      },
      {
        id: 'deliveryMode',
        name: 'checkoutProgress.deliveryMode',
        routeName: 'checkoutDeliveryMode',
        type: [CheckoutStepType.DELIVERY_MODE]
      },
      {
        id: 'reviewOrder',
        name: 'checkoutProgress.reviewOrder',
        routeName: 'checkoutReviewOrder',
        type: [CheckoutStepType.REVIEW_ORDER]
      }
    ]
  }
}
